import type { FC } from 'react';
import type { CenteredColonProps } from './CenteredColon.types';
import styles from './CenteredColon.module.scss';
const CenteredColon: FC<CenteredColonProps> = ({
  className
}) => {
  return <div className={cn(styles.root, className)} data-sentry-component="CenteredColon" data-sentry-source-file="CenteredColon.tsx">
      <div className={styles.dot} />
      <div className={styles.dot} />
    </div>;
};
export { CenteredColon };